// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.float-logo {
    background-color: rgba(255, 255, 255, 0.5);
    min-height: 20px;
    min-width: 20px;
    position: fixed;
    bottom: 30px;
    width: 50%;
    max-width: 250px;
    left: 0;
    padding: 20px;
    /* above the map container, below dialogs and the bars */
    z-index: 5;
    pointer-events: none;
}

.float-logo img {
    width: 100%;
}

/* No logo in the top bar (the logo link wraps the image when logoUrl is set) */
div.TopBar img.topbar-logo,
div.TopBar a:has(> img.topbar-logo) {
    display: none;
}
`, "",{"version":3,"sources":["webpack://./js/style/FloatLogo.css"],"names":[],"mappings":"AAAA;IACI,0CAA0C;IAC1C,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,OAAO;IACP,aAAa;IACb,wDAAwD;IACxD,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA,+EAA+E;AAC/E;;IAEI,aAAa;AACjB","sourcesContent":[".float-logo {\n    background-color: rgba(255, 255, 255, 0.5);\n    min-height: 20px;\n    min-width: 20px;\n    position: fixed;\n    bottom: 30px;\n    width: 50%;\n    max-width: 250px;\n    left: 0;\n    padding: 20px;\n    /* above the map container, below dialogs and the bars */\n    z-index: 5;\n    pointer-events: none;\n}\n\n.float-logo img {\n    width: 100%;\n}\n\n/* No logo in the top bar (the logo link wraps the image when logoUrl is set) */\ndiv.TopBar img.topbar-logo,\ndiv.TopBar a:has(> img.topbar-logo) {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
